import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueCookies from 'vue-cookies'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts'
import 'echarts-wordcloud'
import { message } from '@/util/resetMessage'

import './assets/css/reset.css'

import './util/rem'

import axios from 'axios'
Vue.prototype.$http = axios

Vue.use(ElementUI)

Vue.use(VueCookies)

Vue.prototype.$echarts = echarts

// 挂载
Vue.prototype.$message = message

Vue.config.productionTip = false

// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.Authorization) {
      config.headers.common.Authorization = store.state.Authorization
    }
    return config
  },
  error => {
    // 对请求错误做什么
    return Promise.reject(error)
  })

// http reponse响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code === 50) {
      store.commit('del_Authorization')
      store.commit('del_name')
      store.commit('del_userName')
      store.commit('del_userType')
      store.commit('del_userKind')
      router.replace({
        path: '/login'
      })
    } else {
      return response
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit('del_Authorization')
          store.commit('del_name')
          store.commit('del_userName')
          store.commit('del_userType')
          store.commit('del_userKind')
          router.replace({
            path: '/login'
          })
      }
    }
  })

// 路由守卫：对需登录页面（meta.requiresAuth）做登录态校验
// 注意：前端守卫只是体验层拦截，真正的数据鉴权必须由后端接口完成
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.state.Authorization) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  // 后台管理仅限 userKind === '1'（用户组，UI 层控制；真鉴权在后端）
  if (to.meta.requiresAdmin &&
      store.state.userKind !== '1' &&
      localStorage.getItem('userKind') !== '1') {
    next('/')
    return
  }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
